import { httpPost, httpGet } from './request/index'

// 添加回收点
export function savePostHouse (data) {
  return httpPost('postHouse/savePostHouse', data)
}
// 回收点列表
export function findPostHouseList (data) {
  return httpPost('postHouse/findPostHouseList', data)
}

// 回收点详情
export function getPostHouseInfo (data) {
  return httpPost('postHouse/getPostHouseInfo', data)
}
// 删除回收点
export function delPostHouse (data) {
  return httpPost('postHouse/delPostHouse', data)
}
// 回收点地图列表
export function findPostHouseListOnMap (data) {
  return httpPost('postHouse/findPostHouseListOnMap', data)
}
// 回收点地图列表  ||  商店管理人员列表
export function recycleUserList (data) {
  return httpPost('recycle/recycleUserList', data)
}

// 回收点商品类型列表
export function goodsTypeList (data) {
  return httpPost('postHouseGoodsType/findPostHouseGoodsTypeList', data)
}

// 保存回收点商品类型
export function saveHouseGoods (data) {
  return httpPost('postHouseGoodsType/savePostHouseGoodsType', data)
}

// 获取类型详情
export function getTypeInfo (data) {
  return httpPost('postHouseGoodsType/getPostHouseTypeInfo', data)
}

// 删除类型
export function deteleTypeInfo (data) {
  return httpPost('postHouseGoodsType/delPostHouseGoodsType', data)
}

// 添加品牌关联
export function updateBrand (data) {
  return httpPost('postHouseGoodsType/updatePostHouseGoodsTypeBrand', data)
}
// 品牌列表
export function findBrandList (data) {
  return httpPost('postHouseGoodsBrand/findPostHouseGoodsBrandList', data)
}
// 添加品牌列表
export function saveBrand (data) {
  return httpPost('postHouseGoodsBrand/savePostHouseGoodsBrand', data)
}
// 获取品牌详情
export function getBrandInfo (data) {
  return httpPost('postHouseGoodsBrand/getPostHouseBrandInfo', data)
}
// 删除品牌
export function delBrand (data) {
  return httpPost('postHouseGoodsBrand/delPostHouseGoodsBrand', data)
}
// 获取多级商品类型
export function getPostHouseGoodsTypeJsonList (data) {
  return httpPost('postHouseGoodsType/getPostHouseGoodsTypeJsonList', data)
}

// 添加回收点管理人员
export function addPostHouseUserInfo (data) {
  return httpPost('recycle/addPostHouseUserInfo', data)
}

// 回收点列表
export function getRecyclePointList (data) {
  return httpPost('recyclePoint/getRecyclePointList', data)
}

// 新增回收点
export function pointSave (data) {
  return httpPost('recyclePoint/save', data)
}

// 删除回收点
export function pointDel (data) {
  return httpPost('/recyclePoint/del', data)
}
// 查看回收点
export function getRecyclePoint (data) {
  return httpPost('/recyclePoint/getRecyclePoint', data)
}

// 获取回收点垃圾记录列表
export function getRecyclePointRecordList (data) {
  return httpPost('/recyclePoint/getRecyclePointRecordList', data)
}

// 循环商店列表
export function findPostHouseStoreList (data) {
  return httpPost('/postHouseStore/findPostHouseStoreList', data)
}
// 获取循环商店信息
export function getPostHouseStore (data) {
  return httpPost('/postHouseStore/getPostHouseStore', data)
}
// 商店保存
export function savePostHouseStore (data) {
  return httpPost('/postHouseStore/savePostHouseStore', data)
}
// 商店删除
export function delPostHouseStore (data) {
  return httpPost('/postHouseStore/delPostHouseStore', data)
}
// 获取回收点循环商店回收人员个数、回收点数量、循环商店数量
export function findPostHouseCountInfo (data) {
  return httpPost('/postHouseStore/findPostHouseCountInfo', data)
}
// 获取回收点树信息
export function getPostHouseTree (data) {
  return httpPost('/postHouseStore/getPostHouseTree', data)
}
// hone列表
export function getList (data) {
  return httpPost('/product/getList', data)
}
// hone列表
export function getHoneList (data) {
  return httpPost('/product/getHoneList', data)
}
